'use client'
import { avatars } from '../playground-avatar/config/avatars'
import Demo from './Demo'

export default function PrivacyPolicyPage() {
  // on prd and dev it's the same component id
  const COMPONENT = 'comp-ug.safety_and_privacy_robot.talk_with_robot-rtaz'
  const PERSONA = '64b0c4affdd22f6c2c18d400f2ac5db7'
  const AVATAR = avatars.robot

  return (
    <Demo componentId={COMPONENT} personaId={PERSONA} avatarAsset={AVATAR} />
  )
}
